export default __webpack_public_path__ + "static/media/thrivingpets-logo-dark-reverse.c5cca075.svg";